<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <v-card class='elevation-2 animated fadeIn' >
                    <v-toolbar flat>
                        <v-toolbar-title>Dashboard</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex sm12 md6 v-if="viewEscuelasCertificadas">
                                <v-card class='elevation-2 animated fadeIn'>
                                    <v-toolbar flat>
                                        <v-toolbar-title>Escuelas Certificadas</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <escuelasCertificadas></escuelasCertificadas>
                                    </v-card-text>
                                    <v-card-actions>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                            <v-flex sm12 md6 v-if="viewEstudiantesSeleccionados">
                                <v-card class='elevation-2 animated fadeIn'>
                                    <v-toolbar flat>
                                        <v-toolbar-title>Estudiantes Graduados</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <estudiantesSeleccionados></estudiantesSeleccionados>
                                    </v-card-text>
                                    <v-card-actions>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                            <v-flex sm12 md6 v-if="viewProgresoTransacciones">
                                <v-card class='elevation-2 animated fadeIn'>
                                    <v-toolbar flat>
                                        <v-toolbar-title>Progreso de Transacciones</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <progresoTransacciones></progresoTransacciones>
                                    </v-card-text>
                                    <v-card-actions>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                            <v-flex sm12 md6 v-if="viewStatusTransacciones">
                                <v-card class='elevation-2 animated fadeIn'>
                                    <v-toolbar flat>
                                        <v-toolbar-title>Estatus de Transacciones</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <statusTransacciones></statusTransacciones>
                                    </v-card-text>
                                    <v-card-actions>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import script from './script'
    export default script
</script>



// WEBPACK FOOTER //
// src/components/dashboard/index/component.vue